// The reason for this is that we used to have a rule in cloudflare that would redirect all /flights*
// routes loaded from outside but now we needed the /flightssearch/s from being linked from outside
export default function (location) {
	if (location.pathname.match(/^\/[a-z]{2}-[a-z]{2}\/flightssearch/)) return;
	if (location.pathname.match(/\/flightssearch\/s.*/)) return;
	if (location.pathname === "/flightssearch") return;
	if (location.pathname.match(/\/flights.*/)) {
		location.assign("/");
	}
}
